import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('notificationPreferences', app)

  store.getters.listByEventType = (state) => {
    const result = {}
    const data = state.list.default.data
    if (!data) return result
    data.forEach((pref) => {
      if (pref.eventType) {
        if (!result[pref.eventType]) {
          result[pref.eventType] = {}
        }
        result[pref.eventType][pref.channel] = pref
      }
    })
    return result
  }

  return store
}
